import controller from './add-user.controller';

const template = require('./add-user.html');

export default {
    bindings: {
        onCreate: '&',
        onCancel: '&'
    },
    controller,
    template
};



// WEBPACK FOOTER //
// ./app/components/users-and-access/users/add-user/add-user.component.js